import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ui-feedback-body',
  template: '<div [innerHtml]="content() | translate: contentParams()"></div>',
  styleUrl: './feedback-body.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeedbackBodyComponent {
  content = input.required<string>();
  contentParams = input<Record<string, string> | undefined>({});
}
